
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SubmitAgency from '../pages/submit/page';
import Exchange from '../pages/exchange/page';
import Portal from '../pages/portal/page';
import SignIn from '../pages/signin/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/submit',
    element: <SubmitAgency />,
  },
  {
    path: '/exchange',
    element: <Exchange />,
  },
  {
    path: '/signin',
    element: <SignIn />,
  },
  {
    path: '/portal',
    element: <Portal />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
